import angular from 'angular';
import { schemaServiceFactory } from './schemaService.factory';

export const schemaServiceModule = angular
  .module('bit.services.schemaService', [])
  .factory('schemaService', schemaServiceFactory);
